import { render, staticRenderFns } from "./SchedaMorteCodificaGemo.vue?vue&type=template&id=a40f851c"
import script from "./SchedaMorteCodificaGemo.vue?vue&type=script&lang=js"
export * from "./SchedaMorteCodificaGemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports